import { render } from "./auditModuleReviewer.vue?vue&type=template&id=64a8a80a"
import script from "./auditModuleReviewer.vue?vue&type=script&lang=js"
export * from "./auditModuleReviewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__